import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UploadComponent } from './upload/upload.component';
import { AnalysingComponent } from './analysing/analysing.component';
import { SummaryComponent } from './summary/summary.component';
import { GenerateMappingComponent } from './generate-mapping/generate-mapping.component';
import { MappingResultComponent } from './mapping-result/mapping-result.component';



@NgModule({
  declarations: [
    UploadComponent,
    AnalysingComponent,
    SummaryComponent,
    GenerateMappingComponent,
    MappingResultComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ]
})
export class CustomModule { }
